document.addEventListener('DOMContentLoaded', function load() {

    if($(".pwGreetingCardsMain").length){
        //GREETING CARDS PAGE
        $(".pwGreetingCardsMain").addClass("breadcrumbs");
        $("ul.pw_breadcrumb").removeClass("pw_breadcrumb");

        $('.pwGreetingCardsText').insertBefore('.pwGreetingCardsMain');
        $('.pwGreetingCardsText').addClass('newPWGreetingCardsText');
        $('.newPWGreetingCardsText').html("<div class='greeting-card-text'>Make every occasion unforgettable with our <b>Personalised Greeting Cards</b>. From birthdays and congratulations to Christmas, we've got thousands of designs to suit every moment. Add a name, special date, photo, or personal message to create a card that's truly one-of-a-kind.<br><br>Each card is printed on demand and delivered direct - a thoughtful way to show you care. Order before <b>1pm for same-day dispatch!</b> And at just <b>£3.99</b>, it's amazing value for a personalised keepsake they'll treasure.</div>");
    }
    
  
}, false);

document.addEventListener('DOMContentLoaded', function load() {
    if (!window.jQuery) return setTimeout(load, 50);

  	 var pw_button = $("#pw_cart_button");
     var staticProduct = $("#pw_static_product");
  
     if ($(".main-product").length && (pw_button.length || staticProduct.length) ){
        setTimeout(function(){ 
       		$(".shopify-payment-button").hide();
         },1000);
       
       $(document).on("change", ".selector-wrapper select", function(e){
       	$(".shopify-payment-button").hide();
       });
     }

    if($(".main-product").length && pw_button.length){
      $("body").addClass("pw-product");
        
      function personaliseButton(){

        $("body").on('DOMSubtreeModified', "#pw_personalisation_id", function() {

          var pw_button_text = $("#pw_cart_button").val();
          if(pw_button_text == "Personalise"){
            $('#pw_cart_button').val('Edit');
            setTimeout(function(){ 
              $(".pwAddToCart").show();
              $('.pwAddToCart').prop('disabled', false);
            },1000);
          } 

        });


        // Select the node that will be observed for mutations
        var targetNode = document.getElementById('pw_personalisation_id');

        // Options for the observer (which mutations to observe)
        var config = { attributes: true, childList: true };

        // Callback function to execute when mutations are observed
        var callback = function(mutationsList) {
          //for(var mutation of mutationsList) {
          for(var mutation in mutationsList) {

            var pw_button_text = $("#pw_cart_button").val();
            if(pw_button_text == "Personalise"){
              $('#pw_cart_button').val('Edit');
              setTimeout(function(){ 
                $(".pwAddToCart").show();
                 $('.pwAddToCart').prop('disabled', false);
              },1000);
            }
          }

        };

        // Create an observer instance linked to the callback function
        var observer = new MutationObserver(callback);

        // Start observing the target node for configured mutations
        observer.observe(targetNode, config);

        var pw_button = $("#pw_cart_button");
        if (typeof pw_button  !== "undefined"){
          setTimeout(function(){
            $(".shopify-payment-button, .pwAddToCart").hide();
          },3000);

        }
      }

      personaliseButton();

     /* $(document).on("click", ".product__modal-opener", function(){

          var product_image = $(".product__media img").attr('src');
          $(".cross-sells--featured-image img").attr("srcset", product_image);
          $(".cross-sells--featured-image img").attr("src", product_image);
        
        
      });*/

     /* $(document).on("click", ".pwAddToCart", function(){
        setTimeout(function(){ 
            var product_image = $(".product__media img").attr('src');
            
            $("#cart-notification .cart-notification-product__image img").attr("srcset", product_image);
            $("#cart-notification .cart-notification-product__image img").attr("src", product_image);
        },2000);
      });*/

      function pwVariationChange(){

        

        var pw_cart_button = $("#pw_cart_button").html();
        if (typeof  pw_cart_button !== 'undefined'){
          var pw_button_text = $("#pw_cart_button").val();
          if(pw_button_text == "Edit"){
			            
            var product_image_original = $('meta[property="og:image"]').attr('content');
			
            setTimeout(function(){ 
    
              $(".product__media img").attr("data-src", product_image_original);
              $(".product__media img").attr("data-bgset", product_image_original);
              $(".product__media img").attr("src", product_image_original);
              $(".product__media img").attr("srcset", product_image_original);

            }, 500);
           
            if (document.documentMode || /Edge/.test(navigator.userAgent)) {
              $("#pw_cart_button").prop('value', 'Personalise');
            } else{
              $('#pw_cart_button').val('Personalise');
            }


            
          }

          
          
          setTimeout(function(){ 
            $('.pwProductSelect option').removeAttr('selected');
              $(".shopify-payment-button, .pwAddToCart").hide();
             var variantID = $(".product-variant-id").val();
              $('.pwProductSelect option[value='+variantID+']').attr('selected','selected');
             
           },1000);
        }

      }
      var variantID = $(".product-variant-id").val();
              $('.pwProductSelect option[value='+variantID+']').attr('selected','selected');
      $("select.select__select").on("change", function(e){
  		
         pwVariationChange();

      });

    }

  
  
}, false);

  
